import React from 'react'
import './pill.css'

export const Pill = ({className, color, children, active, onClick}) => {
  let classNames = [`pill`,`pill--color--${color}`]
  if (active) {
    classNames = [...classNames, `pill--active--${color}`]
  }
  if (className) {
    classNames = [...classNames, className]
  }
  return (
    <li className={classNames.join(' ')} onClick={onClick}>{children}</li>
  )
}



// WEBPACK FOOTER //
// ./src/core/components/pill/Pill.js